import { purchaseOrderStatusName } from '../constants/purchase-order-status.js';
export function canShipPurchaseOrder(statusName) {
    return (statusName === purchaseOrderStatusName.ISSUED || statusName === purchaseOrderStatusName.SHIPPED);
}
//# sourceMappingURL=can-ship-purchase-order.js.map